/**
 * Auth-aware breadcrumb.
 * Home → `/` when logged out; `{ICM_URL}/platform` when logged in (Stocks/Global use
 * post-login product listing hard-refresh instead).
 * Re-exports the client implementation so all call sites share that behavior.
 */
export { default, type BreadcrumbPath } from "./breadcrumb.client";
export type { BreadcrumbPathSerializable } from "./breadcrumb.types";
export {
    getHomeBreadcrumbRoute,
    resolveHomeBreadcrumbPaths,
} from "./breadcrumb-utils";
